import { WalletTokenState } from '../coinLiquidation/walletTokenFetcher';
import { LiquidationAsset } from '../coinLiquidation/types';

export const filterTokensByCMC = async (
  walletState: WalletTokenState,
  fetchCMCTokenPrices: () => Promise<any>
): Promise<WalletTokenState> => {
  try {
    // Fetch CMC token list
    const cmcTokens = await fetchCMCTokenPrices()
    console.log('walletState', walletState)
    console.log('cmcTokens', cmcTokens)
    if (!cmcTokens || typeof cmcTokens !== 'object' || Object.keys(cmcTokens).length === 0) {
      return walletState
    }

    const validAddresses = new Set<string>()

    Object.keys(cmcTokens).forEach(chainName => {
      const chainTokens = cmcTokens[chainName]
      if (chainTokens && typeof chainTokens === 'object') {
        Object.keys(chainTokens).forEach(tokenAddress => {
          if (tokenAddress.startsWith('0x')) {
            validAddresses.add(tokenAddress.toLowerCase())
          }
        })
      }
    })

    const filteredTokenByNetwork: Record<string, LiquidationAsset[]> = {}
    Object.keys(walletState.tokenByNetwork).forEach(chainId => {
      const networkTokens = walletState.tokenByNetwork[chainId]
      const filteredTokens = networkTokens.filter(token => {
        // Check by address (primary)
        const address = token.address?.toLowerCase() || '';
        const isEvmAddress = address.startsWith('0x');
        if (!isEvmAddress) {
          return true;
        }
        if (address && validAddresses.has(address)) {
          return true
        }
        if (token.isNative) {
          return true
        }
        return false
      })

      if (filteredTokens.length > 0) {
        filteredTokenByNetwork[chainId] = filteredTokens
      }
    })

    const filteredTokensList: LiquidationAsset[] = []
    Object.values(filteredTokenByNetwork).forEach(tokens => {
      filteredTokensList.push(...tokens)
    })

    const filteredState: WalletTokenState = {
      ...walletState,
      tokenByNetwork: filteredTokenByNetwork,
      tokensList: filteredTokensList
    }

    return filteredState
  } catch (error) {
    return walletState
  }
}
